export default __webpack_public_path__ + "static/media/graph.b3ccfbb9.svg";